import { getDueDateStatusFromDate } from "./dueDateStatus";

export function getBgColorFromDate(dateString) {
    const status = getDueDateStatusFromDate(dateString);
    return status?.bgClass || "bg-slate-400";
}
